import * as Sentry from "@sentry/react";
import { get } from "../ApiHandler/apihandler";

// const LOADER_DELAY = 1000;
const fetchData = async (url, setUserData, setIsLoading) => {
  try {
    setIsLoading(true);
    const response = await get(url);
    if (response.ok) {
      const data = await response.json();
      setUserData(data.data);
    } else {
      console.error("Failed to fetch user data");
    }
  } catch (error) {
    Sentry.captureException(error);
  } finally {
    setIsLoading(false);
  }
};

export default fetchData;
